import { Skeleton } from 'v5/design-system/Skeleton';
import { menuPaddingLeft } from 'v5/patterns/sidebar/menuPadding';
import { cn } from 'v5/platform/dom/cn';

export type EnterpriseMenuCollapsibleSkeletonProps = {
  count?: number;
  level?: number;
};

/** Mirrors `MenuCollapsible` trigger row layout. */
export function EnterpriseMenuCollapsibleSkeleton({
  count = 3,
  level = 0
}: EnterpriseMenuCollapsibleSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={`menu-collapsible-skeleton-${index}`}
          className="flex flex-col gap-0.5"
          aria-hidden
        >
          <button
            type="button"
            disabled
            className={cn(
              'flex items-center gap-3 py-2 rounded text-[13px] w-full border border-transparent pointer-events-none pr-3'
            )}
            style={{ paddingLeft: menuPaddingLeft(level) }}
          >
            <Skeleton className="size-6 rounded-sm" />
            <Skeleton className="h-4 min-w-12 w-1/3 mr-auto rounded" />
            <span className="flex items-center gap-1">
              <Skeleton className="size-4 shrink-0 rounded-sm" />
            </span>
          </button>
        </div>
      ))}
    </>
  );
}
